import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { useAuthStore } from '@stores/auth'
import React from 'react'
import { RouteName } from '../routeNames'
import { Account } from '../routes/Account'
import { Home } from '../routes/Home/Home'
import { Messaging } from '../routes/Messaging'
import { Tracking } from '../routes/Tracking'

type TabDefinition = {
  [key in RouteName]?: { icon?: IconProp; component?: React.FC }
}

export function getTabs(): TabDefinition {
  const hasMessaging = !!useAuthStore.getState().user?.enableMessaging

  return {
    [RouteName.Home]: {
      icon: ['fad', 'house-heart'],
      component: Home,
    },
    [RouteName.Tracking]: {
      icon: ['fad', 'chart-pie'],
      component: Tracking,
    },
    ...(hasMessaging && {
      [RouteName.PseudoTabAddTracking]: {},
      [RouteName.Messaging]: {
        icon: ['fad', 'messages'],
        component: Messaging,
      },
    }),
    [RouteName.Account]: {
      icon: ['fad', 'user'],
      component: Account,
    },
    ...(!hasMessaging && { [RouteName.PseudoTabAddTracking]: {} }),
  }
}
